export function formatPaymentNumber(number: number): string {
    return `PAY-${String(number).padStart(4, '0')}`;
}
